import { Button, IconButton } from "@chakra-ui/react"
import { ShuffleIcon } from "@pathwright/pathicons"
import Error from "@pathwright/ui/src/components/error/Error"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { usePdfInfoResult } from "@pathwright/ux/src/components/filestack/api"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { useMeasure } from "react-use"
import styled from "styled-components"
import { useCertificateState } from "../context/CertificateState"
import CertificateTemplate from "./CertificateTemplate"
import CertificateTemplateReplace from "./CertificateTemplateReplace"
import InvalidCertificateTemplateError from "./InvalidCertificateTemplateError"

const Container = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  min-width: 100%;

  /* Hiding media manager spinner */
  .LoadingCircle {
    display: none;
  }
`

const CertificateTemplateForm = ({ hash }) => {
  const {
    certificateState: { template }
  } = useCertificateState()
  const { t } = useTranslate()
  const [nodeRef, size] = useMeasure()
  const { data: pdfInfo, error: pdfInfoError } = usePdfInfoResult(template)

  const renderButton = ({ onClick }) =>
    template ? (
      pdfInfoError ? (
        <InvalidCertificateTemplateError onSelectPdf={onClick} />
      ) : pdfInfo && pdfInfo.pages !== 1 ? (
        <Error
          errorTitle={t("Invalid page size.")}
          errorMessage={t(
            "The certificate template PDF must contain only one page. Found {{ count }}.",
            {
              count: pdfInfo.pages
            }
          )}
          primaryAction={{
            icon: "arrow-up-circle",
            label: "Select a PDF",
            onClick
          }}
        />
      ) : (
        <>
          <CertificateTemplate hash={hash} scaleSize={size} />
          <IconButton
            aria-label="Replace certificate template"
            size="sm"
            position="absolute"
            top="10px"
            right="10px"
            zIndex="10"
            variant="solid"
            colorPalette={"blackAlpha"}
            onClick={onClick}
            children={<ShuffleIcon size="1.2em" />}
          />
        </>
      )
    ) : (
      <Button onClick={onClick} variant="solid" colorPalette="brand" gap={2}>
        <Pathicon icon="arrow-up-circle" />
        Select a PDF
      </Button>
    )

  return (
    <Container ref={nodeRef} className="CertificateTemplateForm">
      <CertificateTemplateReplace renderButton={renderButton} />
    </Container>
  )
}

CertificateTemplateForm.displayName = "CertificateTemplateForm"

export default CertificateTemplateForm
